import { useApp } from '../../state/AppContext';
import { badge, mapBadge } from '../../lib/format';
import { cardPad } from '../../lib/ui';

const CAT_TH: Record<string, string> = { 'Insurance': 'ประกันภัย', 'IT & Office': 'ไอทีและสำนักงาน' };
const REG_TH: Record<string, string> = { 'Verified': 'ยืนยันแล้ว', 'Pending': 'รอดำเนินการ' };
const STATUS_TH: Record<string, string> = { 'Pending': 'รอดำเนินการ', 'Under Review': 'กำลังตรวจสอบ' };

export default function Review() {
  const { go, L } = useApp();

  const reviewPending = [
    { id: 'SUP-008', name: 'Orion Marine Insurance', cat: 'Insurance', contact: 'ops@orion-marine.co', reg: 'Pending', registered: '2026-06-18', status: 'Pending' },
    { id: 'SUP-009', name: 'GeoTrack Solutions', cat: 'IT & Office', contact: 'sales@geotrack.io', reg: 'Verified', registered: '2026-06-16', status: 'Under Review' },
    { id: 'SUP-010', name: 'Northgate Insurance', cat: 'Insurance', contact: 'bids@northgate.co', reg: 'Pending', registered: '2026-06-20', status: 'Pending' },
  ].map((s) => {
    const b = badge(s.status);
    const r = badge(s.reg === 'Verified' ? 'Verified' : 'Pending');
    return {
      ...s,
      stBg: b.bg, stFg: b.fg, regBg: r.bg, regFg: r.fg,
      catLabel: L(s.cat, CAT_TH[s.cat] ?? s.cat),
      regLabel: L(s.reg, REG_TH[s.reg] ?? s.reg),
      statusLabel: L(s.status, STATUS_TH[s.status] ?? s.status),
      onReview: () => go('reviewdetail'),
    };
  });

  const reviewCompleted = [
    { id: 'SUP-003', name: 'Crestline Insurance', outcome: L('Approved · Tier B', 'อนุมัติแล้ว · ระดับ B'), ...mapBadge('Verified') },
    { id: 'SUP-011', name: 'Zenith Underwriters', outcome: L('Rejected', 'ปฏิเสธแล้ว'), ...mapBadge('Cancelled') },
  ];

  return (
    <>
      <div style={{ ...cardPad(0, 'auto'), marginBottom: 16 }}>
        <div style={{ padding: '14px 18px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('Pending Reviews', 'รอการตรวจสอบ')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Supplier ID', 'รหัสซัพพลายเออร์')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Company', 'บริษัท')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Category', 'หมวดหมู่')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Contact', 'ผู้ติดต่อ')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Registry', 'ทะเบียน')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Registered', 'ลงทะเบียนแล้ว')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Status', 'สถานะ')}</th>
              <th style={{ textAlign: 'right', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Actions', 'การดำเนินการ')}</th>
            </tr>
          </thead>
          <tbody>
            {reviewPending.map((s) => (
              <tr key={s.id} style={{ borderBottom: '1px solid var(--color-border)' }}>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{s.id}</td>
                <td style={{ padding: '12px 16px', fontWeight: 600 }}>{s.name}</td>
                <td style={{ padding: '12px 16px', color: 'var(--color-fg-2)' }}>{s.catLabel}</td>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--color-fg-2)' }}>{s.contact}</td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: s.regBg, color: s.regFg }}>{s.regLabel}</span>
                </td>
                <td style={{ padding: '12px 16px', fontFamily: 'var(--font-mono)', color: 'var(--color-fg-2)' }}>{s.registered}</td>
                <td style={{ padding: '12px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: s.stBg, color: s.stFg }}>{s.statusLabel}</span>
                </td>
                <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                  <button onClick={s.onReview} className="hv-primary" style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 'var(--radius-sm)', background: 'var(--color-primary)', color: '#fff' }}>{L('Review', 'ตรวจสอบ')}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={cardPad(0, 'auto')}>
        <div style={{ padding: '14px 18px', fontWeight: 700, borderBottom: '1px solid var(--color-border)' }}>{L('Completed Reviews', 'ตรวจสอบเสร็จสิ้น')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--color-mist)', borderBottom: '1px solid var(--color-border)' }}>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Supplier ID', 'รหัสซัพพลายเออร์')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Company', 'บริษัท')}</th>
              <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)' }}>{L('Outcome', 'ผลลัพธ์')}</th>
            </tr>
          </thead>
          <tbody>
            {reviewCompleted.map((s) => (
              <tr key={s.id} style={{ borderBottom: '1px solid var(--color-border)' }}>
                <td style={{ padding: '11px 16px', fontFamily: 'var(--font-mono)', fontWeight: 600 }}>{s.id}</td>
                <td style={{ padding: '11px 16px' }}>{s.name}</td>
                <td style={{ padding: '11px 16px' }}>
                  <span style={{ fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 999, background: s.stBg, color: s.stFg }}>{s.outcome}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
